var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-column align-center transcript-score-gauge" },
    [
      _c(
        "TranscriptRingGauge",
        {
          attrs: {
            value: _vm.scoreValue,
            max: _vm.max,
            color: _vm.color,
            "track-color": _vm.track,
            size: _vm.size
          }
        },
        [
          _c(
            "span",
            {
              staticClass: "font-semibold transcript-score-gauge__value",
              style: _vm.valueStyle
            },
            [_vm._v(" " + _vm._s(_vm.formatted) + " ")]
          )
        ]
      ),
      _vm.hasScore
        ? _c("span", { staticClass: "d-inline-flex align-center mt-3" }, [
            _c("span", {
              staticClass: "transcript-score-gauge__dot mr-2",
              style: { background: _vm.tier.color }
            }),
            _c(
              "span",
              { staticClass: "az-text-primary az-size-12 font-semibold" },
              [_vm._v(_vm._s(_vm.tier.label))]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }